import Marionette from 'backbone.marionette';

export default class PulseController extends Marionette.Object {
	pulse(){
		location.href = '/pulse/index.html';
	}
}